import React from 'react';
import { useSelector } from 'react-redux';
import { selectFluxPersonalizedFormShowInstructions } from 'redux/reducers/fluxPersonalizedFormReducer';
import {
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import useNewStudyForm from 'utils/hooks/flux/personalized/useNewStudyForm';
import TextField from 'components/DesignSystem/TextField';
import Button from 'components/DesignSystem/Button';
import FormAccordion from './Accordion';

export default function PersonalizedForm() {
  const {
    name, setName, addScenarioDisabled, onAddScenarioClick, onCancelClick,
  } = useNewStudyForm();
  const showInstructions = useSelector(selectFluxPersonalizedFormShowInstructions);

  return (
    <Form>
      <Row>
        <Col>
          <Form.Group controlId="PersonalizedFileName" className="mb-3">
            <TextField
              label="Nome do Estudo"
              required
              type="text"
              value={name}
              onChange={(e) => { setName(e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
      <FormAccordion />
      <Row className="mt-3">
        {showInstructions && (
          <Button
            disabled={addScenarioDisabled}
            onClick={onAddScenarioClick}
          >
            Adicionar Cenário
          </Button>
        )}
      </Row>
      <Row>
        <Button
          type="tertiary"
          onClick={onCancelClick}
          className="mt-2"
        >
          Cancelar Estudo
        </Button>
      </Row>
    </Form>
  );
}
